'use client'

import { useContext } from 'react'

import { ResizeContext } from '../../../../apps/storefront/src/context/resize-context'

export const useIsDesktop = () => {
  const windowSize = useContext(ResizeContext)

  return windowSize >= 1024
}
